import { t } from "@/i18n";
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Paintbrush, Sparkles } from "lucide-react";
import { api, pageImageUrl } from "@/lib/api";
import { Loader } from "@/components/Loader";

const TILTS = ["rotate-[-1.5deg]", "rotate-[1deg]", "rotate-[2deg]", "rotate-[-1deg]"];

export default function ColourPicker() {
  const [pages, setPages] = useState(null);
  useEffect(() => {
    api.get("/pages").then((r) => setPages(r.data)).catch(() => setPages([]));
  }, []);
  if (!pages) return <Loader label={t("finding_your_pages")} />;
  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 py-10" data-testid="colour-picker-page">
      <div className="mb-10 rise">
        <h1 className="text-4xl sm:text-5xl font-bold tracking-tight">{t("pick_a_picture_to_colour")}</h1>
        <p className="text-slate-600 mt-2 text-base sm:text-lg">{t("tap_one_to_open_the_colouring_studio")}</p>
      </div>
      {pages.length === 0 ? (
        <div className="card-soft p-12 text-center space-y-4" data-testid="colour-empty-state">
          <p className="font-display text-2xl font-semibold">{t("no_pages_yet")}</p>
          <p className="text-slate-600">{t("ask_a_grown_up_to_create_one_first")}</p>
          <Link to="/create" className="btn-pop btn-red inline-flex" data-testid="colour-empty-create-button"><Sparkles className="w-5 h-5" /> {t("create_a_page")}</Link>
        </div>
      ) : (
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">
          {pages.map((p, i) => (
            <Link key={p.id} to={`/colour/${p.id}`} data-testid={`colour-pick-${p.id}`}
              className={`group bg-white rounded-3xl p-3 border-4 border-[#1E293B] shadow-[5px_6px_0_0_#1E293B] hover:-translate-y-1 transition-transform duration-200 ${TILTS[i % 4]}`}>
              <img src={pageImageUrl(p.id)} alt={p.title} loading="lazy" className="w-full aspect-square object-contain rounded-2xl bg-white" />
              <div className="flex items-center justify-between px-2 pt-3 pb-1">
                <p className="font-display font-semibold text-lg truncate">{p.title}</p>
                <span className="w-10 h-10 rounded-full bg-[#4ECDC4] flex items-center justify-center shrink-0 group-hover:scale-110 transition-transform"><Paintbrush className="w-5 h-5" /></span>
              </div>
            </Link>
          ))}
        </div>
      )}
    </div>
  );
}
